import { DashboardLayout } from "./DashboardLayout";
import { MarketingLayout } from "./MarketingLayout";
import { usePlatform } from "..//PlatformContext";

export type Props = {
  title: string;
};

export function SupportLayout({ title }: Props) {
  const { user } = usePlatform();

  const isUserLoggedIn = !!user;

  return isUserLoggedIn ? (
    <DashboardLayout title={title} />
  ) : (
    <MarketingLayout title={title} />
  );
}

export default SupportLayout;
